import { render, staticRenderFns, recyclableRender, components } from "./pro_admin.vue?vue&type=template&id=a055c968&"
var renderjs
import script from "./pro_admin.vue?vue&type=script&lang=js&"
export * from "./pro_admin.vue?vue&type=script&lang=js&"
import style0 from "./pro_admin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/user/my_shop/pro_admin.vue"
export default component.exports